import React from 'react';
import '../components/PricingCom.css'
import { Link } from 'react-router-dom';

const  PricingCom = () => {
    return (
        <div className='pricing'>
            <div className='card-container'>
                <div className='card'>
                    <h3> - Basic - </h3>
                    <span className='bar'></span>
                    <p className='btc'>1 Btc</p>
                    <p> - 3 Days - </p>
                    <p> - Views - </p>
                    <p> - Featured - </p>
                    <Link to='/Contact' className='btn'>Book</Link>
                </div>
                <div className='card'>
                    <h3> - Suite - </h3>
                    <span className='bar'></span>
                    <p className='btc'>3 Btc</p>
                    <p> - 5 Days - </p>
                    <p> - Views - </p>
                    <p> - Featured - </p>
                    <Link to='/Contact' className='btn'>Book</Link>
                </div>
                <div className='card'>
                    <h3> - Executive - </h3>
                    <span className='bar'></span>
                    <p className='btc'>7 Btc</p>
                    <p> - 12 Days - </p>
                    <p> - Views - </p>
                    <p> - Featured - </p>
                    <Link to='/Contact' className='btn'>Book</Link>
                </div>
            </div>
        </div>
    );
}





export default PricingCom ;



